import { gql } from '@apollo/client'
import { REQUEST_BASIC_PROPS, PURCHASED_BASIC_PROPS } from './fragments'

export const ASK_REQUEST = gql`
  mutation AskRequest($input: RequestInput!) {
    askRequest(input: $input) {
      token
      refreshToken
      requestType
      requestId
      user {
        id
        email
        name
      }
    }
  }
`

export const LOGIN = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      refreshToken
      user {
        id
        email
        name
      }
    }
  }
`

export const FORGOT_PASSWORD = gql`
  mutation ForgotPassword($email: String!, $magicLink: Boolean) {
    forgotPassword(email: $email, magicLink: $magicLink) {
      ok
      message
    }
  }
`

export const CHECK_MAGIC_LINK = gql`
  mutation CheckMagicLink($token: String!) {
    checkMagicLink(token: $token) {
      token
      refreshToken
      user {
        id
        email
        name
      }
    }
  }
`

export const RESET_PASSWORD = gql`
  mutation ResetPassword(
    $token: String!
    $password: String!
    $repeatedPassword: String
  ) {
    resetPassword(
      token: $token
      password: $password
      repeatedPassword: $repeatedPassword
    ) {
      ok
      message
      email
    }
  }
`

export const UPDATE_VALUE = gql`
  mutation UpdateValue(
    $requestType: UpdateRequestEnum!
    $requestId: String
    $input: UpdateInput!
  ) {
    updateValue(
      requestType: $requestType
      requestId: $requestId
      input: $input
    ) {
      user {
        id
        email
        name
        billingInfo {
          email
          name
          company
          country
          address
          city
          zip
          phone
          vat
          extraInfo
        }
        supervision {
          ...RequestBasicProps
        }
        quote {
          ...RequestBasicProps
        }
        purchased {
          ...PurchasedBasicProps
        }
      }
    }
  }
  ${REQUEST_BASIC_PROPS}
  ${PURCHASED_BASIC_PROPS}
`

export const UPDATE_MESSAGES = gql`
  mutation UpdateMessages(
    $requestType: RequestEnum
    $requestId: String
    $message: String!
  ) {
    updateMessages(
      requestType: $requestType
      requestId: $requestId
      message: $message
    ) {
      user {
        id
        messages {
          time
          id
          content
          author
        }
        supervision {
          messages {
            time
            id
            content
            author
          }
        }
        quote {
          messages {
            time
            id
            content
            author
          }
        }
      }
    }
  }
`
